import { GradientButton } from '../../components/button/GradientButton';
import { useCreateMerchantAccount } from '../../hooks/useCreateMerchantAccount';
import { t } from '../../services/translation/translation';

export const CreateMerchantAccountButton = () => {
  const { mutate: createMerchantAccount, isLoading } = useCreateMerchantAccount();

  return (
    <GradientButton onClick={() => createMerchantAccount()} isLoading={isLoading}>
      {t('common.activate')}
    </GradientButton>
  );
};
